import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import Select from 'pages/reference-implementation/components/select';
import { InputLabel } from 'pages/reference-implementation/components/input-label';
import { OrderPayload } from 'pages/reference-implementation/provisioning/RI003AWS/store';

const Department = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);

    const departmentApi = useMutation((sector) => axios.get(endPoints.aws.Ec2.department(sector)));

    const seldValueExistsInOptions = (departmentValue) => options.find((option) => departmentValue === option?.value);

    const handleOnSelectChange = (selected) => {
        if (selected && seldValueExistsInOptions(selected?.value)) {
            setOrder({
                ...order,
                department: selected.value,
                environment: null,
                landingZoneDetails: null,
                componentName: null,
                componentNameDetails: null,
                isSecurityGroupRequired: false,
            });
        }
    };

    React.useEffect(() => {
        if (departmentApi?.isSuccess && departmentApi?.data?.data?.departments) {
            const { departments } = departmentApi.data.data;
            const departmentOptions = departments
                .filter((dept) => {
                    if (order?.sector === 'CMP') return ['CMP'].includes(dept.departmentDisplayName);
                    if (order?.sector === 'CGF') return ['AISP'].includes(dept.departmentDisplayName);
                    return true;
                })
                .map((dept) => ({
                    label: dept.departmentDisplayName,
                    value: dept.departmentBackendName,
                    data: {
                        name: dept.departmentBackendName,
                        displayName: dept.departmentDisplayName,
                    },
                }));
            setOptions(departmentOptions);
        }
    }, [departmentApi?.isSuccess, departmentApi?.data]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.department) {
            const selectedOption = options[0];
            setOrder({ ...order, department: selectedOption.value, departmentDetail: selectedOption.data, selectedDepartmentOption: selectedOption });
        }
        if (options && options?.length && order?.department && !order?.selectedDepartmentOption) {
            const department = seldValueExistsInOptions(order?.department);
            if (department) setOrder({ ...order, department: department.value, departmentDetail: department.data, selectedDepartmentOption: department });
        }
    }, [options]);

    React.useEffect(() => {
        if (order?.sector) {
            departmentApi.mutate(order.sector);
        } else {
            setOptions([]);
            if (order?.department) {
                setOrder({ ...order, department: null, departmentDetail: null, selectedDepartmentOption: null });
            }
        }
    }, [order?.sector]);

    React.useEffect(() => {
        if (!order?.department && order?.isTouched) setIsTouched(true);
    }, [order?.department, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                key="department"
                label={<InputLabel label="Department" isRequired />}
                value={order?.department || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isLoading={departmentApi?.isLoading}
                isRequired={isTouched}
                disabled={departmentApi?.isLoading || !order?.sector}
                // onBlur={() => setIsTouched(true)}
            />
        </Box>
    );
};

export default React.memo(Department);
